import React, { Component } from "react";
import { Grid } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import Progress from "./CustomTool/Progress";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import {
  applyTrimOnObjectValues,
  get_YMD_from_SYS,
  isValidItem,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";
import { fetchLedgerMaster, fetchLoadUnload } from "./API";
import TableList from "./CustomTool/TableList";
import CtCmbEditable from "./CustomTool/CtCmbEditable";

class VehicleUnload extends Component {
  state = {
    DeliveryPerson: [],
    LoadingSrNo: [],
    Packing: [],
    TaxName: [],
    autoEnableDisalbe_Col_Info: [],
    columns: [
      { id: "Action", label: "", name: "" },
      { id: "dat_loaddateDMY", label: "Loading Date" },
      { id: "vac_orderitemno", label: "Order No" },
      { id: "Check", label: "", name: "SelectUnload" },
      { id: "vac_storename", label: "Store Name" },
      //   {
      //     id: 'itemname', label: 'Item Name', type: 'CtTxt',
      //     CtrlProps: {
      //         value: '', width: 50, maxLength: 20,
      //         autoEnableDisable: true,
      //         defaultValueColID: '',
      //         // autoSet: [{ colID: 'vac_partyname' }],
      //         onKeyDown: this.props.onKeyDown,
      //         autoFocusNextCol: true,
      //         guj2eng: true,
      //     }
      // },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_unit", label: "Unit" },
      { id: "dec_loadqty", label: "Quantity" },
      // { id: "purrate", label: "Pur Rate" },
      // { id: "rate", label: "Rate" },
      // { id: "basicamt", label: "Basic Amt" },
      // { id: "dis(%)", label: "Dis (%)" },
      // { id: "disamt", label: "Dis Amt" },
      // { id: "taxable", label: "Taxable" },
      // { id: "taxname", label: "Tax Name" },
      // { id: "cgst", label: "CGST" },
      // { id: "sgst", label: "SGST" },
      // { id: "igst", label: "IGST" },
      // { id: "totalamount", label: "Total Amount" },
      // { id: "remark", label: "Remark" },
    ],

    actionList: [
      {
        name: "SelectUnload",
        icon: "", //<CheckBoxOutlineBlankIcon color="primary" />,
        link: "VehicleUnload:",
        actionType: "Chk",
      },
    ],
    formData: {
      txtDRP: "",
      txtUnloadStore: "",
      dtpUnloadDate: get_YMD_from_SYS(new Date()),
      txtRemark: "",
      cmbDRP: "",
    },
    searchData: {
      vac_storename: "",
      vac_itemname: "",
      vac_unit: "",
      dec_loadqty: "",
      // quantity: "",
      // purrate: "",
      // rate: "",
      // basicamt: "",
      // dis: "",
      // disamt: "",
      // taxable: "",
      // taxname: "",
      // cgst: "",
      // sgst: "",
      // igst: "",
      // totalamount: "",
      // remark: "",
    },
    rows: [],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    counter: 0,
    rowsCount: 0,
    rowsPerPage: 50,
    dataLoadStatus: true,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Unloading Entry";
    this.props.setActiveMenu("VehicleUnload");
    this.setSearchColumns();
    this.onFormload();
  }
  //#endregion Component

  onFormload = () => {
    // this.props.notifyProcessing();
    let reqData = {
      Op: "GetDRPLedger",
      bint_acid: localStorage.getItem("acid"),
      vac_username: "",
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        let DeliveryPerson = res.data.LedgerNameList;
        this.setState(
          {
            dataLoadStatus: true,
            DeliveryPerson,
          },
          () => {}
        );
      })
      .catch((error) => {
        this.props.toastMsg(
          "error",
          "Unkonwn Error occured in onFormLoad. " + error
        );
      });
    document.getElementById("cmbDRP").focus();
  };

  validateUnoad = () => {
    let result = false;
    if (this.state.formData.cmbDRP <= 0) {
      this.props.toastErrorMsg("Select Delivery Responsible Name", "cmbDRP");
    } else if (
      isValidItem(
        this.state.DeliveryPerson,
        "vac_ledgername",
        this.state.formData.cmbDRP
      ) == false
    ) {
      this.props.toastErrorMsg(
        "Select Valid Delivery Responsible Name",
        "cmbDRP"
      );
    } else {
      result = true;
    }
    return result;
  };

  validateCheckBox = () => {
    let result = false;
    if (this.state.rows.length <= 0) {
      this.props.toastErrorMsg("Complete List proceess", "cmbDRP");
    } else if (this.state.rows.length > 0) {
      for (let i = 0; i < this.state.rows.length; i++) {
        if (this.state.rows[i].Action !== undefined) {
          if (this.state.rows[i].Action === true) {
            return true;
          }
        }
      }
      this.props.toastErrorMsg("Check At Least One CheckBox", "SelectOrder");
    } else {
      result = true;
    }
    return result;
  };

  trimFormData = (nextFunctionCall) => {
    // console.log("this.state.formData before SetSate", this.state.formData);
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      // console.log("this.state.formData After SetSate", this.state.formData);
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validatesave = () => {
    let result = false;
    if (this.state.formData.dtpUnloadDate <= 0) {
      this.props.toastErrorMsg("Select Unload Date", "dtpUnloadDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpUnloadDate,
        "dtpUnloadDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else {
      result = true;
    }
    return result;
  };

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.dec_loadqty.length === 0 ||
            (row["dec_loadqty"] &&
              row["dec_loadqty"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_loadqty.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  handleOnList = () => {
    // let dataLoadStatus = false;
    if (this.validateUnoad()) {
      this.props.notifyProcessing();
      let reqData = {
        Op: "UnloadingData",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        vac_drp: this.state.formData.cmbDRP,
      };
      fetchLoadUnload(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let rows = res.data.PendingUnloadingList,
            rowsCount = rows.length;
          this.setState(
            {
              dataLoadStatus: true,
              rows,
              rowsCount,
            },
            () => {}
          );
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in onFormLoad. " + error
          );
        });
    }
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          cmbDRP: "",
          dtpUnloadDate: get_YMD_from_SYS(new Date()),
          txtRemark: "",
        },
        rows: [],
        rowsCount: 0,
      },
      () => {
        document.getElementById("cmbDRP").focus();
      }
    );
  };

  handleOnSave = () => {
    // console.log("save")
    if (this.validatesave() && this.validateCheckBox()) {
      // console.log("inside save");
      let Checkrows = [];
      this.state.rows.filter((row) => {
        if (row.Action === true) {
          Checkrows.push({
            bint_loadingsrno: row.bint_loadingsrno,
            bint_itemsrno: row.bint_itemsrno,
            dec_unloadqty: row.dec_loadqty,
            vac_orderitemno: row.vac_orderitemno,
          });
        }
      });
      this.props.notifyProcessing();
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        let reqData = {
          Op: "SaveUnloading_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_unloadingsrno: "",
          dat_unloaddate: this.state.formData.dtpUnloadDate,
          vac_unloadremark: this.state.formData.txtRemark,
          ItemData: Checkrows,
        };
        fetchLoadUnload(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState(
                {
                  dataLoadStatus: true,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            this.props.toastMsg(
              "error",
              "Unkonwn Error occured in onFormLoad. " + error
            );
          });
      });
    }
  };

  OnSelectAll = () => {
    let rows = this.state.rows.map((row) => {
      // console.log(row);
      row.Action = true;
      return row;
    });
    this.setState({
      rows,
    });
  };

  OnDeselectAll = () => {
    let rows = this.state.rows.map((row) => {
      // console.log(row);
      row.Action = false;
      return row;
    });
    this.setState({
      rows,
    });
  };

  //#endregion Handle

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vac_storename",
        label: "Store Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "50",
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        // items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "20",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        items: this.state.Packing,
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "20",
      },
      {
        cType: "CtTxt",
        id: "quantity",
        label: "Quantity",
        value: this.state.searchData.dec_loadqty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "20",
      }
      // {
      //   cType: "CtTxt",
      //   id: "rate",
      //   label: "Rate",
      //   value: this.state.searchData.rate,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "basicamt",
      //   label: "Basic Amt",
      //   value: this.state.searchData.basicamt,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "dis",
      //   label: "Dis",
      //   value: this.state.searchData.dis,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "disamt",
      //   label: "Dis Amt",
      //   value: this.state.searchData.disamt,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "taxable",
      //   label: "Taxable",
      //   value: this.state.searchData.taxable,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "taxname",
      //   items: this.state.TaxName,
      //   label: "Tax Name",
      //   value: this.state.searchData.taxname,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "cgst",
      //   label: "CGST",
      //   value: this.state.searchData.cgst,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "sgst",
      //   label: "SGST",
      //   value: this.state.searchData.sgst,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "igst",
      //   label: "IGST",
      //   value: this.state.searchData.igst,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "totalamount",
      //   label: "Total Amount",
      //   value: this.state.searchData.totalamount,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      // {
      //   cType: "CtTxt",
      //   id: "remark",
      //   label: "Remark",
      //   value: this.state.searchData.remark,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // }
    );
    this.setState({ searchColumns });
  };

  render() {
    // console.log("this.state.dataLoadStatus", this.state.dataLoadStatus);
    // console.log("this.state.rows", this.state.rows);
    const rows = this.state.searchOpen
      ? this.state.searchRows
      : this.state.rows;
    const rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Unloading Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbDRP"
              label="Delivery Responsible Person"
              items={this.state.DeliveryPerson}
              value={this.state.formData.cmbDRP}
              colID="vac_ledgername"
              handleOnChange={this.handleOnChange}
              width={280}
              maxLength={50}
            />
          </Grid>
          <Grid item marginTop={1}>
            <CtBtn label="List" onClick={this.handleOnList} />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpUnloadDate"
              label="Unload Date"
              width="170"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpUnloadDate}
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpUnloadDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtRemark"
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={this.state.formData.txtRemark}
              handleOnChange={this.handleOnChange}
              maxLength={1500}
              width="330"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
          marginBottom={1}
        >
          <br />
          <Grid item>
            <CtBtn label="Select All" onClick={this.OnSelectAll} />
          </Grid>
          <Grid item>
            <CtBtn label="Deselect All" onClick={this.OnDeselectAll} />
          </Grid>
        </Grid>
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          headRowFontColor="#ffffff"
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          // handleOnSearchChange={this.handleOnSearchChange}
          // searchColumns={this.state.searchColumns}
          // searchData={this.state.searchData}
          handleOnRowDataChange={this.handleOnRowDataChange}
          // handleOnChangeAutoEnableDisalbe_ColIdxs={this.handleOnChangeAutoEnableDisalbe_ColIdxs}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Vehicle Load Entry"
        />
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn
              label="Save"
              onClick={() => {
                this.trimFormData(() => {
                  this.handleOnSave();
                });
              }}
            />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} />
          </Grid>
          {/* <Grid item>
            <CtBtn label="Delete" />
          </Grid> */}
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(VehicleUnload))));
